export const applicationFeatures = [
    {
        name: "Analytics",
        permissions: [
            {
                name: "Full Access",
                value: "analytics:*",
                description: "Grants complete access to all analytics features."
            },
            {
                name: "View Brokerage Analytics",
                value: "analytics:view_brokerage",
                description: "Allows viewing brokerage analytics data."
            },
            {
                name: "View Premium Analytics",
                value: "analytics:view_premium",
                description: "Allows viewing premium analytics data."
            },
            {
                name: "View Fac. Premium Analytics",
                value: "analytics:view_fac_premium",
                description: "Allows viewing facultative premium analytics data."
            },
            {
                name: "View Sum. Insured Analytics",
                value: "analytics:view_sum_insured",
                description: "Allows viewing sum insured analytics data."
            },
            {
                name: "View Fac. Sum Insured Analytics",
                value: "analytics:view_fac_sum_insured",
                description: "Allows viewing facultative sum insured analytics data."
            },
        ]
    },
    {
        name: "Offers",
        permissions: [
            {
                name: "Full Access",
                value: "offers:*",
                description: "Grants complete access to all offers features."
            },
            {
                name: "Manage Offers",
                value: "offers:manage",
                description: "Allows overseeing and managing all offers."
            },
            {
                name: "View Offers",
                value: "offers:view",
                description: "Allows viewing existing offers."
            },
            {
                name: "Create Offers",
                value: "offers:create",
                description: "Allows creating new offers for customers."
            },
            {
                name: "Update Offers",
                value: "offers:update",
                description: "Allows editing existing offers."
            },
            {
                name: "Reinstate Offers",
                value: "offers:reinstate",
                description: "Allows reinstatement of offers."
            },
            {
                name: "Payment on Offers",
                value: "offers:payment",
                description: "Allows managing payment on offers."
            },
            {
                name: "Delete Offers",
                value: "offers:delete",
                description: "Allows deleting offers from the system."
            }
        ]
    },
    {
        name: "Endorsements",
        permissions: [
            {
                name: "Full Access",
                value: "endorsements:*",
                description: "Grants complete access to all endorsement features."
            },
            {
                name: "Manage Endorsements",
                value: "endorsements:manage",
                description: "Allows managing endorsement records."
            },
            {
                name: "View Endorsements",
                value: "endorsements:view",
                description: "Allows viewing existing endorsements."
            },
            {
                name: "Create Endorsements",
                value: "endorsements:create",
                description: "Allows creating new endorsements."
            },
            {
                name: "Update Endorsements",
                value: "endorsements:update",
                description: "Allows updating existing endorsements."
            },
            {
                name: "Delete Endorsements",
                value: "endorsements:delete",
                description: "Allows deleting endorsements from the system."
            }
        ]
    },
    {
        name: "Treaties",
        permissions: [
            {
                name: "Full Access",
                value: "treaties:*",
                description: "Grants complete access to all treaty features."
            },
            {
                name: "Manage Treaties",
                value: "treaties:manage",
                description: "Allows managing treaty agreements and terms."
            },
            {
                name: "Create Treaties",
                value: "treaties:create",
                description: "Allows creating new treaty records."
            },
            {
                name: "Update Treaties",
                value: "treaties:update",
                description: "Allows editing and updating treaty details."
            },
            {
                name: "Import Treaties",
                value: "treaties:import",
                description: "Allows bulk import of treaties from files or systems."
            },
            {
                name: "Delete Treaties",
                value: "treaties:delete",
                description: "Allows deleting treaties."
            }
        ]
    },
    {
        name: "Insurers",
        permissions: [
            {
                name: "Full Access",
                value: "insurers:*",
                description: "Grants complete access to all insurer features."
            },
            {
                name: "Manage Insurers",
                value: "insurers:manage",
                description: "Allows managing insurer records."
            },
            {
                name: "Create Insurers",
                value: "insurers:create",
                description: "Allows creating new insurer records."
            },
            {
                name: "Update Insurers",
                value: "insurers:update",
                description: "Allows editing and updating insurer details."
            },
            {
                name: "Assign Insurers",
                value: "insurers:assign",
                description: "Allows assigning insurers to specific cases or clients."
            },
            {
                name: "Delete Insurers",
                value: "insurers:delete",
                description: "Allows deleting insurers."
            }
        ]
    },
    {
        name: "Reinsurers",
        permissions: [
            {
                name: "Full Access",
                value: "reinsurers:*",
                description: "Grants complete access to all reinsurer features."
            },
            {
                name: "Manage Reinsurers",
                value: "reinsurers:manage",
                description: "Allows managing reinsurer records."
            },
            {
                name: "Create Reinsurers",
                value: "reinsurers:create",
                description: "Allows creating new reinsurer records."
            },
            {
                name: "Update Reinsurers",
                value: "reinsurers:update",
                description: "Allows editing and updating reinsurer details."
            },
            {
                name: "Delete Reinsurers",
                value: "reinsurers:delete",
                description: "Allows deleting reinsurers."
            }
        ]
    },
    {
        name: "Reinsurance Brokers",
        permissions: [
            {
                name: "Full Access",
                value: "reinsurance_brokers:*",
                description: "Grants complete access to all reinsurance broker features."
            },
            {
                name: "Manage Reinsurance Brokers",
                value: "reinsurance_brokers:manage",
                description: "Allows managing reinsurance broker records."
            },
            {
                name: "Create Reinsurance Brokers",
                value: "reinsurance_brokers:create",
                description: "Allows creating new reinsurance broker records."
            },
            {
                name: "Update Reinsurance Brokers",
                value: "reinsurance_brokers:update",
                description: "Allows editing and updating reinsurance broker details."
            },
            {
                name: "Assign Reinsurance Brokers",
                value: "reinsurance_brokers:assign",
                description: "Allows assigning reinsurance brokers to specific cases or clients."
            },
            {
                name: "Delete Reinsurance Brokers",
                value: "reinsurance_brokers:delete",
                description: "Allows deleting reinsurance brokers."
            }
        ]
    },

    {
        name: "Business",
        permissions: [
            {
                name: "Full Access",
                value: "business:*",
                description: "Grants complete access to all business features."
            },
            {
                name: "Manage Business",
                value: "business:manage",
                description: "Allows managing business entities and settings."
            },
            {
                name: "Create Business",
                value: "business:create",
                description: "Allows adding new businesses into the system."
            },
            {
                name: "Update Business",
                value: "business:update",
                description: "Allows editing business records."
            },
            {
                name: "Delete Business",
                value: "business:delete",
                description: "Allows deleting business records."
            }
        ]
    },
    {
        name: "Treaty Programmes",
        permissions: [
            {
                name: "Full Access",
                value: "treaty_program:*",
                description: "Grants complete access to all treaty programme features."
            },
            {
                name: "Manage Treaty Programmes",
                value: "treaty_program:manage",
                description: "Allows managing treaty programme configurations."
            },
            {
                name: "Create Treaty Programmes",
                value: "treaty_program:create",
                description: "Allows creating new treaty programmes."
            },
            {
                name: "Update Treaty Programmes",
                value: "treaty_program:update",
                description: "Allows editing existing treaty programmes."
            },
            {
                name: "Import Treaty Programmes",
                value: "treaty_program:import",
                description: "Allows bulk importing treaty programmes."
            },
            {
                name: "Delete Treaty Programmes",
                value: "treaty_program:delete",
                description: "Allows deleting treaty programmes."
            }
        ]
    },
    {
        name: "Reports",
        permissions: [
            {
                name: "Full Access",
                value: "reports:*",
                description: "Grants complete access to all report features."
            },
            {
                name: "Manage Reports",
                value: "reports:manage",
                description: "Allows managing all reports and their settings."
            },
            {
                name: "Create Reports",
                value: "reports:create",
                description: "Allows creating new reports."
            },
            {
                name: "Update Reports",
                value: "reports:update",
                description: "Allows editing and updating reports."
            },
            {
                name: "Import Reports",
                value: "reports:import",
                description: "Allows importing report data in bulk."
            },
            {
                name: "Delete Reports",
                value: "reports:delete",
                description: "Allows deleting reports from the system."
            }
        ]
    },
    {
        name: "Employees",
        permissions: [
            {
                name: "Full Access",
                value: "employees:*",
                description: "Grants complete access to all employee features."
            },
            {
                name: "Manage Employees",
                value: "employees:manage",
                description: "Allows managing employee records."
            },
            {
                name: "Add Employees",
                value: "employees:create",
                description: "Allows adding new employees to the system."
            },
            {
                name: "Update Employees",
                value: "employees:update",
                description: "Allows editing employee information."
            },
            {
                name: "Reset Employees",
                value: "employees:reset",
                description: "Allows resetting employee data to default values."
            },
            {
                name: "Delete Employees",
                value: "employees:delete",
                description: "Allows deleting employee records."
            }
        ]
    }
];
